/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { dataCentersGetApiV3DataCentersDcId } from "../../funcs/dataCentersGetApiV3DataCentersDcId.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetApiV3DataCentersDcIdRequest$inboundSchema,
};

export const tool$dataCentersGetApiV3DataCentersDcId: ToolDefinition<
  typeof args
> = {
  name: "data-centers-get-api-v3-data-centers-dc-id",
  description: ``,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await dataCentersGetApiV3DataCentersDcId(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
